import moment from 'moment'

export function getForemanAssignment(assignments) {

    let foremanAssignment = {}

    assignments.every(assignment => {
        if(assignment.crewMember.classification === "F") { 
            foremanAssignment = {...assignment}
            return false
        }

        return true
    })

    return foremanAssignment
}

export function decideStatus(assignments) {

    let needsPreliminaryCount = 0
    let needsFinalCount = 0
    let needsPaymentCount = 0
    let isPaidCount = 0
    let paidDate = null
    let ticketStatus = "No Crew Members Assigned"

    // Check if there are no assignments
    if(assignments.length === 0) {
        return "No Crew Members Assigned"
    }

    // Check each assignment - workflow order: Preliminary → Final → Payment → Paid
    assignments.forEach((assignment) => {
        
        if(assignment.isPaid) {
            // Step 3: Paid (completed)
            isPaidCount++
            paidDate = moment(assignment.paidDate)
        }
        else if(assignment.finalApproval) {
            // Step 2: Final approved but not paid yet
            needsPaymentCount++
        }
        else if(assignment.preliminaryApproval) {
            // Step 1: Preliminary approved but not final approved yet
            needsFinalCount++
        }
        else {
            // Not even preliminary approved yet
            needsPreliminaryCount++
        }
    })

    // Determine status based on workflow priority
    // Show the earliest incomplete step
    if(needsPreliminaryCount > 0) {
        ticketStatus = 'Needs Preliminary Approval'
    }
    else if(needsFinalCount > 0) {
        ticketStatus = 'Needs Final Approval'
    }
    else if(needsPaymentCount > 0) {
        ticketStatus = 'Needs Payment'
    }
    else if(isPaidCount === assignments.length) {
        ticketStatus = `Paid on ${paidDate.format("MM/DD/YYYY")}`
    }

    return ticketStatus
}